// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xd-1";
export var printerIcon = "_xd-0";